import { Component, EventEmitter, Input, Output } from "@angular/core";
import { RippleModule } from "primeng/ripple";
import { NgClass } from "@angular/common";

@Component({
    selector: "app-playlist-element",
    templateUrl: './playlist-element.component.html',
    styleUrls: ['./playlist-element.component.scss'],
    standalone: true,
    imports: [NgClass, RippleModule]
})

export class PlaylistElementComponent {
    @Input() playlist: any;
    @Output() addToPlaylist: EventEmitter<number>;
    @Output() elementClickEvent: EventEmitter<number>;
    @Input() selectedId: number;
    selected: boolean = false;

    constructor() {
        this.addToPlaylist = new EventEmitter<number>(null);
        this.elementClickEvent = new EventEmitter<number>(null);
    }

    addToPlaylistClick() {
        this.addToPlaylist.emit(this.playlist.id);
    }

    elementClick() {
        this.elementClickEvent.emit(this.playlist.id);
        if (this.selectedId === this.playlist.id) {
            this.selected = !this.selected;
        } else {
            this.selected = true;
        }
    }

}